module.exports = __webpack_public_path__ + "img/line-pay.c160393f.png";